import apiClient from './api';
import authService from './authService';

class OperatorService {
  // Get all operators
  async getOperators() {
    try {
      const response = await apiClient.get('/OperatorAccess/current');
      return response.data.data; // Returns the operators array
    } catch (error) {
      console.error('Operators API Error:', error);
      throw error.response?.data?.message || 'Failed to fetch operators.';
    }
  }

  // Get operator by ID
  async getOperatorById(operatorId) {
    try {
      const response = await apiClient.get(`/operators/${operatorId}`);
      return response.data;
    } catch (error) {
      console.error('Operator API Error:', error);
      throw error.response?.data?.message || 'Failed to fetch operator details.';
    }
  }
}

export default new OperatorService();